/* ──────────────────────────────────────────────────────────────────────
   Product before & after — sections/product-before-after.liquid

   The divider position lives in one custom property (--ba-pos) on the
   figure; the clip on the "before" layer and the handle both read it, so
   moving the slider is a single style write.

   The <input type="range"> is the control, which means click-to-jump,
   drag and arrow keys all work without any pointer bookkeeping. On top
   of that we forward pointer drags that start anywhere on the figure, so
   dragging the visible handle (which sits above the input) still works.
   ────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function initBeforeAfter(section) {
    const figure = section.querySelector('[data-ba-figure]');
    const range = section.querySelector('[data-ba-range]');
    if (!figure || !range) return;

    /* Once one side takes more than this share of the frame, the other
       side is too narrow to carry its caption, so that caption fades out
       and only the dominant one is left. */
    const DOMINANT_SIDE = 60;

    function apply(value) {
      const pos = Number(value);
      figure.style.setProperty('--ba-pos', pos + '%');
      figure.classList.toggle('is-hiding-after', pos > DOMINANT_SIDE);
      figure.classList.toggle('is-hiding-before', pos < 100 - DOMINANT_SIDE);
    }

    apply(range.value);
    range.addEventListener('input', () => apply(range.value));

    /* Pointer drags anywhere on the figure. The range already handles
       this for its own hit area, but the handle and the captions sit on
       top, so without this a drag started on the handle would do nothing. */
    let dragging = false;

    function positionFromEvent(event) {
      const rect = figure.getBoundingClientRect();
      if (!rect.width) return null;
      const ratio = (event.clientX - rect.left) / rect.width;
      return Math.min(100, Math.max(0, ratio * 100));
    }

    figure.addEventListener('pointerdown', (event) => {
      const pos = positionFromEvent(event);
      if (pos === null) return;
      dragging = true;
      figure.setPointerCapture(event.pointerId);
      range.value = pos;
      apply(pos);
    });

    figure.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const pos = positionFromEvent(event);
      if (pos === null) return;
      /* Keep the page scrollable until the gesture is clearly horizontal;
         CSS touch-action: pan-y already lets vertical swipes through. */
      event.preventDefault();
      range.value = pos;
      apply(pos);
    });

    function endDrag(event) {
      if (!dragging) return;
      dragging = false;
      if (figure.hasPointerCapture(event.pointerId)) {
        figure.releasePointerCapture(event.pointerId);
      }
    }

    figure.addEventListener('pointerup', endDrag);
    figure.addEventListener('pointercancel', endDrag);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-before-after]').forEach(initBeforeAfter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  /* Re-initialise when the Theme Editor re-renders this section. */
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
